var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center",staticStyle:{"min-height":"40px"}},_vm._l((_vm.keywords),function(word){return _c('v-chip',{key:word,staticClass:"ma-2",attrs:{"close":"","color":"gray","text-color":"black","small":""},on:{"click:close":function($event){return _vm.onClickRemove(word)}}},[_vm._v(" "+_vm._s(word)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }